import React from 'react';
import {Flex} from '@chakra-ui/react';
import {Route, Switch, useRouteMatch} from 'react-router-dom';
import AuthHome from './AuthHome';
import NotFound from '../../error/404';
import {Helmet} from "react-helmet";
import StudentLogin from "../student/StudentLogin";
import StudentRegister from "../student/StudentRegister";
import CourseRegistration from "../student/CourseRegistration";
import TeacherLogin from "../teacher/TeacherLogin";
import TeacherRegister from "../teacher/TeacherRegister";
import StudentPrivateRoute from "../../../utilities/StudentPrivateRoute";

export default function Auth() {
  let {path, url} = useRouteMatch();
  console.log(path, url);

  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center" h="100vh">
      <Helmet>
        <title>Vidcom | Sign In/SignUp</title>
        <meta name="description" content="Authentication"/>
      </Helmet>
      <Switch>
        <Route exact path={path} component={AuthHome}/>
        <Route path={`${path}/student/login`} component={StudentLogin}/>
        <Route path={`${path}/student/signup`} component={StudentRegister}/>
        <StudentPrivateRoute path={`${path}/student/course-registration`} component={CourseRegistration}/>
        <Route path={`${path}/tutor/login`} component={TeacherLogin}/>
        <Route path={`${path}/tutor/signup`} component={TeacherRegister}/>
        <Route path="*" component={NotFound}/>
      </Switch>
    </Flex>
  )
}
